import { defineComponent as _defineComponent } from 'vue'
import { useContext } from '@nuxtjs/composition-api';
import { ref, computed, onMounted } from 'vue';

import useRecaptcha from '@/composables/useRecaptcha';
import { useForm } from '@/composables';

interface Props {
  success?: boolean;
  pending?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SupportForm',
  props: {
    success: { type: Boolean },
    pending: { type: Boolean }
  },
  setup(__props: any) {


const { formSuccess, formPending, submit } = useForm();

const form = ref({
  type: 'canyon_support',
  email: '',
  comment: '',
  country: '',
  full_name: '',
  product_type: '',
  agreement: false,
});

const { validateRecaptcha } = useRecaptcha();
const recaptchaClicked = ref(false);
const { $recaptcha } = useContext();
const isSubmitNotDisabled = computed(
  () => form.value.agreement && recaptchaClicked.value,
);
const submitForm = async () => {
  const isValid = await validateRecaptcha();
  if (!isValid) return;
  submit(form.value);
};
onMounted(async () => {
  await $recaptcha.init();
});

return { __sfc: true,formSuccess, formPending, submit, form, validateRecaptcha, recaptchaClicked, $recaptcha, isSubmitNotDisabled, submitForm }
}

})